import { useState, useEffect, useMemo } from "react";
import classNames from "classnames";
import { getInitials } from "../../utils/getInitials";

import styles from "./BrandLogo.module.css";

export interface BrandLogoProps {
  logoUrl?: string;
  name: string;
  className?: string;
  size?: "small" | "medium" | "large";
  isSelected?: boolean;
}

const BrandLogo = ({
  logoUrl,
  name,
  className,
  size = "medium",
  isSelected = true,
}: BrandLogoProps) => {
  const [imageError, setImageError] = useState(false);

  const initials = useMemo(() => getInitials(name), [name]);

  const showFallback = !logoUrl || imageError;

  useEffect(() => {
    if (logoUrl) {
      setImageError(false);
    }
  }, [logoUrl]);

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <div
      className={classNames(
        styles.logo,
        styles[`logo_${size}`],
        !isSelected && styles["is-disabled"],
        className
      )}
    >
      {showFallback ? (
        <div className={styles.logo__fallback} role="img" aria-label={`${name} logo`}>
          <span className={styles.logo__initials}>{initials}</span>
        </div>
      ) : (
        <img
          src={logoUrl}
          alt={`${name} logo`}
          className={styles.logo__image}
          onError={handleImageError}
          loading="lazy"
        />
      )}
    </div>
  );
};

export default BrandLogo;
